let _locale = ''
let _apiURL = '/api'

export default {
	
	get locale() {
		return _locale
	},
	
	get localeURL() {
		return _locale ? `/${_locale}` : ''
	},

	get apiURL() {
		return _apiURL
	},

	setupLocale(langCodes) {
		const [, urlLocale] = document.location.pathname.split('/')

		if (langCodes.includes(urlLocale)) {
			_locale = urlLocale
			_apiURL = `/${_locale}/api`
		}
	}

}